var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimelineDot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8075)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_8075",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_8075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0072 25.0036C35.0072 23.0243 34.4203 21.0895 33.3207 19.4437C32.221 17.798 30.6581 16.5153 28.8294 15.7579C27.0008 15.0004 24.9886 14.8022 23.0473 15.1884C21.1061 15.5745 19.3229 16.5277 17.9233 17.9272C16.5237 19.3268 15.5706 21.11 15.1845 23.0512C14.7983 24.9925 14.9965 27.0047 15.754 28.8333C16.5114 30.662 17.7941 32.2249 19.4398 33.3246C21.0856 34.4242 23.0204 35.0111 24.9997 35.0111C27.6539 35.0111 30.1993 33.9567 32.076 32.0799C33.9528 30.2032 35.0072 27.6578 35.0072 25.0036Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.141 3.90603C29.7723 0.123642 42.3123 6.50925 46.0947 18.1406C49.8771 29.7719 43.4915 42.3119 31.8602 46.0943C20.2289 49.8767 7.68886 43.4911 3.90647 31.8598C0.124087 20.2284 6.50969 7.68841 18.141 3.90603ZM30.4106 41.6366C39.5839 38.6535 44.6201 28.7635 41.637 19.5902C38.6539 10.4168 28.764 5.38067 19.5906 8.36375C10.4173 11.3468 5.38112 21.2368 8.3642 30.4101C11.3473 39.5835 21.2373 44.6196 30.4106 41.6366Z",
    fill: "#3A5686"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8075"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineDot);
export default __webpack_public_path__ + "static/media/timeline_dot.d3257b81e85750ecd901bb77f21a1bc9.svg";
export { ForwardRef as ReactComponent };